"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoutePath = exports.ClosedStoreCTA = exports.StoreLocatorStoreListText = exports.fullWeek = exports.weekends = exports.weekdays = exports.HOLIDAYS_DAYS_RANGE = void 0;
var HOLIDAYS_DAYS_RANGE = 300;
exports.HOLIDAYS_DAYS_RANGE = HOLIDAYS_DAYS_RANGE;
var weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
exports.weekdays = weekdays;
var weekends = ['Saturday', 'Sunday'];
exports.weekends = weekends;
var fullWeek = [].concat(weekdays, weekends);
exports.fullWeek = fullWeek;
var StoreLocatorStoreListText;
exports.StoreLocatorStoreListText = StoreLocatorStoreListText;

(function (StoreLocatorStoreListText) {
  StoreLocatorStoreListText["MEASURE"] = "miles";
  StoreLocatorStoreListText["TIMETABLE_LABEL"] = "store hours";
  StoreLocatorStoreListText["TIMETABLE_SPECIAL_LABEL"] = "special hours";
})(StoreLocatorStoreListText || (exports.StoreLocatorStoreListText = StoreLocatorStoreListText = {}));

var ClosedStoreCTA;
exports.ClosedStoreCTA = ClosedStoreCTA;

(function (ClosedStoreCTA) {
  ClosedStoreCTA["CHAT"] = "chat with a stylist";
  ClosedStoreCTA["APPOINTMENT"] = "virtual appointment";
})(ClosedStoreCTA || (exports.ClosedStoreCTA = ClosedStoreCTA = {}));

var RoutePath;
exports.RoutePath = RoutePath;

(function (RoutePath) {
  RoutePath["BOOK_APPOINTMENT"] = "/appointments/personal-stylist";
})(RoutePath || (exports.RoutePath = RoutePath = {}));